import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IIVA } from "src/models/Products/IVA.models";

interface IVAState {
  ivas: IIVA[];
  ivaToEdit: IIVA | null;
}

const initialState: IVAState = {
  ivas: [],
  ivaToEdit: null,
};

const ivaSlice = createSlice({
  name: "IVA",
  initialState,
  reducers: {
    setIVAList: (state, action: PayloadAction<IIVA[]>) => {
      state.ivas = action.payload;
    },
    concatListIVA: (state: IVAState, action: PayloadAction<IIVA[]>) => {
      state.ivas = [...state.ivas.concat(action.payload)];
    },
    setIVAToEdit: (state, action: PayloadAction<IIVA | null>) => {
      state.ivaToEdit = action.payload;
    },
    addIVA: (state, action: PayloadAction<IIVA>) => {
      state.ivas.push(action.payload);
    },
    updateIVA: (state, action: PayloadAction<IIVA>) => {
      let itemIndex = state.ivas.findIndex(
        item => item.ivaId === action.payload.ivaId
      );
      if (itemIndex !== -1) state.ivas[itemIndex] = action.payload;
    },
    deleteIVA: (state, action: PayloadAction<number>) => {
      const newArray = state.ivas.filter(item => item.ivaId !== action.payload);
      state.ivas = newArray;
    },
  },
});

export const {
  setIVAList,
  concatListIVA,
  setIVAToEdit,
  addIVA,
  updateIVA,
  deleteIVA,
} = ivaSlice.actions;

export default ivaSlice.reducer;
